import React, { forwardRef } from 'react';

import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
  IconButton as ChakraIconButton,
  IconButtonProps as ChakraIconButtonProps,
} from '@chakra-ui/react';
import { LoadingSpinner } from '@saas-ui/react';

// Base Button Component
export interface ButtonProps extends ChakraButtonProps {
  /**
   * Loading state
   */
  isLoading?: boolean;
  /**
   * Loading text to show when loading
   */
  loadingText?: string;
  /**
   * Left icon element
   */
  leftIcon?: React.ReactElement;
  /**
   * Right icon element
   */
  rightIcon?: React.ReactElement;
  /**
   * Full width button
   */
  fullWidth?: boolean;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ fullWidth, leftIcon, isLoading, disabled, ...props }, ref) => {
    return (
      <ChakraButton
        ref={ref}
        leftIcon={isLoading ? <LoadingSpinner size='sm' /> : leftIcon}
        width={fullWidth ? 'full' : 'auto'}
        isDisabled={disabled || isLoading}
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';

// Icon Button Component
export interface IconButtonProps extends ChakraIconButtonProps {
  /**
   * Icon element
   */
  icon: React.ReactElement;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, icon, isLoading, ...props }, ref) => {
    return (
      <ChakraIconButton
        ref={ref}
        className={className}
        icon={isLoading ? <LoadingSpinner size='sm' /> : icon}
        {...props}
      />
    );
  }
);

IconButton.displayName = 'IconButton';

// Export all components
export { Button, IconButton };
